/**
 * @author lifei
 * 功能：处理收藏
 */
import { Cache } from '@/tools'
import { omit } from 'lodash-es'

export class Favorite<T extends TCommon.TStore.State> {
  /**
   * 功能：获取收藏列表
   */
  getList = (rootState: T): Promise<T['sFavorites']> => {
    const sFavorites = Cache.FAVORITES.getItem() || []
    rootState.sFavorites = sFavorites
    return Promise.resolve(sFavorites)
  }

  /**
   * 功能：移除收藏标签
   */
  remove = (rootState: T, activeKey: string): Promise<void> => {
    const { sFavorites, sTabs } = rootState
    rootState.sFavorites = sFavorites.filter((item) => item.fullPath !== activeKey)
    const tab = sTabs.find((item) => item.fullPath === activeKey)
    return new Promise((resolve) => {
      Cache.FAVORITES.setItem(rootState.sFavorites)
      if (tab?.meta) {
        tab.meta.collected = false
      }
      Cache.TABS.setItem(rootState.sTabs)
      resolve()
    })
  }

  /**
   * 功能：移除全部收藏标签
   */
  empty = (rootState: T): Promise<void> => {
    const { sFavorites, sTabs } = rootState
    sFavorites.forEach((item) => {
      const tab = sTabs.find((el) => item.fullPath === el.fullPath)
      if (tab?.meta) {
        tab.meta.collected = false
      }
    })

    return new Promise((resolve) => {
      rootState.sFavorites = []
      Cache.FAVORITES.setItem([])
      Cache.TABS.setItem(sTabs)
      resolve()
    })
  }

  /**
   * 功能：添加收藏标签
   */
  add = (rootState: T, state: T['sFavorite']): Promise<void> => {
    const { sFavorites } = rootState
    if (state) {
      const index = sFavorites.findIndex((item) => item.fullPath === state.fullPath)
      index > -1 ? sFavorites.splice(index, 1) : sFavorites.unshift(state)
    }
    return new Promise((resolve) => {
      Cache.FAVORITES.setItem(sFavorites)
      resolve()
    })
  }

  /**
   * 功能：重置收藏列表，用于收藏列表排序等
   */
  resetList = (rootState: T, state: T['sFavorites']): Promise<T['sFavorites']> => {
    rootState.sFavorites = state
    return new Promise((resolve) => {
      Cache.FAVORITES.setItem(rootState.sFavorites)
      resolve(rootState.sFavorites)
    })
  }
}
